export default {

  LOGIN: '/cms/admin/login',
  REFRESH_TOKEN: '/cms/admin/refresh-token',

  GET_ALL_ADMINS: '/cms/admin',

  GET_ALL_APPS: '/cms/apps',

  CATEGORIES_PATH: 'categories',
  LAWS_PATH: 'laws',
  ENTITY_TYPES_PATH: 'laws/entity-types',
};
